import script from "./editAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./editAddress.vue?vue&type=script&setup=true&lang=js"

import "./editAddress.vue?vue&type=style&index=0&id=137cddd8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-137cddd8"]])

export default __exports__